import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import endpoints from "../../api/endpoints";

export interface Client {
  NumeroClient: string;
  RaisonSociale: string;
}

interface ClientsState {
  clients: Client[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: ClientsState = {
  clients: null,
  loading: false,
  error: null,
};

export const fetchClientsBySalesRepresentative = createAsyncThunk(
  "clients/getBySalesRepresentative",
  async () => {


    const response = await axiosInstance.get(
      endpoints.clients.clientsBySalesRepresentative
    );
    return response.data;
  }
);

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientsBySalesRepresentative.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientsBySalesRepresentative.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload;
      })
      .addCase(fetchClientsBySalesRepresentative.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch clients by sales representative!";
      });
  },
});

export default clientsSlice.reducer;
